import { makeStyles, Theme } from "@material-ui/core"

export const useSettingStyles = makeStyles((theme: Theme) => ({
  paper: {
    marginBlockEnd: 20,
    padding: theme.spacing(1),
  },
  inputAlignedButton: {
    alignSelf: "center",
  },
}))
